import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthProvider";

const SplashScreen = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isAuthenticated, loading } = useAuth();

  useEffect(() => {
    document.body.classList.add("login-page-background");
    return () => {
      document.body.classList.remove("login-page-background");
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!loading) {
        if (isAuthenticated) {
          navigate("/home");
        } else {
          navigate("/login");
        }
      }
    }, 2000); // Show splash for 2 seconds

    return () => clearTimeout(timer);
  }, [navigate, isAuthenticated, loading]);

  return (
    <div className="splash-screen fade-in">
      <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
        {" "}
        <img
          src="/brand-avatar.png"
          alt="Sai Sruti"
          style={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            
          }}
        />{" "}
     
      </div>
      <h1 className="brand-title">{t("common.brand")}</h1>
      <p className="brand-tagline">"{t("common.tagline")}"</p>
      <div className="loading-spinner"></div>
    </div>
  );
};

export default SplashScreen;
